import { render, staticRenderFns } from "./ProductSectionComponent.vue?vue&type=template&id=5e9d2d52&"
import script from "./ProductSectionComponent.ts?vue&type=script&lang=ts&"
export * from "./ProductSectionComponent.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductSectionComponent.vue"
export default component.exports